<div class="trash-wrapper breadcrumb-wrapper">
  <span class="path-value"><mat-icon>delete</mat-icon><span>Trash</span></span>

  <span class="trash-info">
    Items in trash automatically deleted after 2 weeks.
  </span>
</div>

<button class="add-item-button" mat-fab extended (click)="backToDashboard()">
  Back to Dashboard
</button>

<app-tree-root
  #itemsDisplayedTree
  [nodes]="displayedTreeNodeTrashItems()"
  [options]="customTemplateOptions"
></app-tree-root>
